import { render } from "./Notificaciones.vue?vue&type=template&id=09d3a41a&scoped=true"
import script from "./Notificaciones.vue?vue&type=script&lang=js"
export * from "./Notificaciones.vue?vue&type=script&lang=js"

import "./Notificaciones.vue?vue&type=style&index=0&id=09d3a41a&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d3a41a"]])

export default __exports__